import styled from "styled-components";

import { Transfer } from "antd";

import { CustomCheckboxStyle } from "../checkbox/atom";

export const StyledTransfer = styled(Transfer)`
  ${CustomCheckboxStyle};
  .ant-empty-description {
    color: hsla(0, 0%, 100%, 0.85);
  }
  .ant-transfer-operation {
    button.ant-btn-primary {
      border-color: #646c77;
      background-color: var(--main-color);
      &:hover {
        background-color: var(--main-color);
      }
      &[disabled] {
        background-color: unset;
        &:hover {
          background-color: unset;
        }
      }
      &[disabled] {
        svg path {
          color: hsla(0, 0%, 100%, 0.85);
        }
      }
    }
  }
`;
